import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import axios from "axios";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Dialog, DialogActions, DialogContent, Button } from "@mui/material";
import { web_url } from "../../constant";

const url = "http://localhost:8080/api/";
function ResearcherGreetingMobilePage() {

    const [language, setLanguage] = useState(() => {
        const categoryNow = localStorage.getItem('language') ? localStorage.getItem('language') : 'English';
        return categoryNow;
    })
    const { t, i18n } = useTranslation();
    useEffect(() => {
        switch (language) {
            case 'English':
                i18n.changeLanguage('en');
                break;
            case 'Sinhala':
                i18n.changeLanguage('si');
                break;
            case 'Tamil':
                i18n.changeLanguage('ta');
                break;
            default:
                i18n.changeLanguage('en');
                break;
        }
        localStorage.setItem('language', language);
    }, [language]);
    const navigate = useNavigate();

    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang);
    };

    const [loadingPage, setLoadingPage] = useState(false);
    const [researcherName, setResearcherName] = useState('');

    useEffect(() => {
        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails = getLogDetails();
        if (logDetails) {
            setLoadingPage(true);

            const configToken = {
                headers: {
                    'Authorization': `Bearer ${logDetails.token}`,
                },
            };

            axios.get(`${web_url}/api/auth/researchers`, configToken).then((resR) => {
                const resMain = resR.data[0].userEmail;
                localStorage.setItem('resMain', resMain);
                const apiUrl = `${web_url}/api/auth/researchers/${logDetails.email}`
                axios.get(apiUrl, configToken)
                    .then((response) => {
                        // console.log(response.data);
                        localStorage.setItem('name', response.data.userFullName);
                        localStorage.setItem('mobile', response.data.contactNumber);
                        setResearcherName(response.data.userFullName)
                        setLoadingPage(false);
                    })
                    .catch((err) => {
                        console.log("error occured");
                    });
            }).catch((errR) => {
                console.log("error occured");
            })
        }
    }, [])
    const [open2, setOpen2] = useState(false);

    useEffect(() => {
        if (loadingPage) {
            setOpen2(true);
        } else {
            setOpen2(false);
        }
    }, [loadingPage])

    const handleClose2 = () => {
        setOpen2(false)
    }

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 1270) {
                navigate('/desktop/researcher/dashboard')
            }
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {

        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };

        const checkAuth = () => {
            const logDetails = getLogDetails();
            const currentTime = new Date();

            if (!logDetails) {
                alert("Please re-sign up to continue");
                localStorage.clear();
                sessionStorage.clear();
                navigate('/loginas');
                return;
            } else if (logDetails.category.toLowerCase() !== "researcher") {
                alert("Please re-sign up to continue");
                // localStorage.clear();
                sessionStorage.clear();
                navigate('/loginas');
                return;
            }

            if (sessionStorage.getItem('exp')) {
                if (new Date(sessionStorage.getItem('exp')) < currentTime) {
                    alert("Please re-sign up to continue");
                    localStorage.clear();
                    sessionStorage.clear();
                    navigate('/loginas');
                } else if (sessionStorage.getItem('exp') !== logDetails.exp) {
                    alert("Please re-sign up to continue");
                    sessionStorage.clear();
                    navigate('/loginas');
                }
            } else {
                sessionStorage.setItem('exp', logDetails.exp);
                if (new Date(logDetails.exp) < currentTime) {
                    alert("Please re-sign up to continue");
                    localStorage.clear();
                    sessionStorage.clear();
                    navigate('/loginas');
                }
            }
        };

        checkAuth(); // Run on mount

        const handleStorageChange = (event) => {
            if (event.key === "logDetails") {
                checkAuth(); // Re-check authentication if storage changes
            }
        };

        window.addEventListener("storage", handleStorageChange);

        return () => {
            window.removeEventListener("storage", handleStorageChange);
        };
    }, []);


    return (
        <div>
            <div className={`${i18n.language === "en" ? "font-urban" : (i18n.language === "si" ? "font-noto" : "font-mukta")} bg-bgImg md:bg-bglarge bg-no-repeat bg-cover min-h-screen w-screen xl:pt-[50px]`}>
                <Menu as="div" className="xl:hidden absolute top-0 right-0 text-left items-right py-[30px] md:py-[35px] pr-[20px] md:pr-[30px] lg:pr-[40px]">
                    <div>
                        <MenuButton className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 lg:py-3 text-sm md:text-[17px] md:text-[21px] font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-black hover:bg-gray-50">
                            {language === "Sinhala" ? "සිංහල" : (language === "Tamil" ? "தமிழ்" : language)}
                            <ChevronDownIcon aria-hidden="true" className="-mr-1 size-5 md:size-6 text-gray-400" />
                        </MenuButton>
                    </div>

                    <MenuItems
                        transition
                        className="absolute right-0 z-10 mt-2 w-[200px] origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                    >
                        <div className="py-1">
                            <MenuItem>
                                <button
                                    className="text-left w-full block px-4 py-2 text-sm md:text-md lg:text-lg text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                    onClick={() => {
                                        setLanguage("English");
                                        changeLanguage('en')
                                    }}
                                >
                                    English
                                </button>
                            </MenuItem>
                            <MenuItem>
                                <button
                                    className="text-left w-full block px-4 py-2 text-sm md:text-md lg:text-lg text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                    onClick={() => {
                                        setLanguage("Sinhala");
                                        changeLanguage('si')
                                    }}
                                >
                                    සිංහල
                                </button>
                            </MenuItem>
                            <MenuItem>
                                <button
                                    className="text-left w-full block px-4 py-2 text-sm md:text-md lg:text-lg text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                    onClick={() => {
                                        setLanguage("Tamil");
                                        changeLanguage('ta')
                                    }}
                                >
                                    தமிழ்
                                </button>
                            </MenuItem>
                        </div>
                    </MenuItems>
                </Menu>

                <div className="xl:hidden flex flex-col items-center pt-[110px] md:pt-[200px] lg:pt-[250px] pb-[120px] md:pb-[20px] ">
                    <div className="flex flex-col pt-[20px] justify-center items-center">
                        <img className="h-[130px] md:h-[160px] lg:h-[200px]" src="/images/logo.svg" alt="logo" />
                        <p className={` ${i18n.language==="en"?"text-[20px] md:text-[30px] lg:text-[35px]":"text-[18px] md:text-[27px] lg:text-[33px]"} pt-[10px] font-semibold `}>{t('t1')}</p>
                        <div className="flex flex-col items-center bg-[#F2AC0E] bg-opacity-20 border border-[#F2AC0E] mr-[20px] ml-[20px] md:mr-[100px] md:ml-[100px] mt-[10px] px-[5px] py-[10px] border-[2px] md:border-[3px] rounded-2xl">
                            <p className="mt-[10px] font-bold text-[18px] md:text-[25px] lg:text-[30px] text-black">{t('t79')} {researcherName}</p>
                            <p className="font-normal text-[15px] md:text-[25px] lg:text-[30px] text-black text-center">{t('t80')}</p>
                            <p className="font-normal text-[15px] md:text-[25px] lg:text-[30px] pt-[10px] hyphens-auto break-words w-[90%] mx-auto ">
                                {t('t196')}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="xl:hidden grid grid-cols-4 fixed bottom-0 w-full border-t border-gray-300 bg-white">
                <div className="flex justify-center py-[20px] lg:py-[30px]"><img src="/images/bottom-icons/home.svg" alt="home" onClick={() => navigate('/mobile/researcher/dashboard')} /></div>
                <div className="flex justify-center py-[20px] lg:py-[30px]"><img src="/images/bottom-icons/person.svg" alt="person" onClick={() => navigate('/mobile/researcher/profile')} /></div>
                <div className="flex justify-center py-[20px] lg:py-[30px]"><img src="/images/bottom-icons/mail.svg" alt="mail" onClick={() => navigate('/mobile/researcher/mailbox/inbox')} /></div>
                <div className="flex justify-center py-[20px] lg:py-[30px]"><img src="/images/bottom-icons/settings.svg" alt="settings" onClick={() => navigate('/mobile/researcher/settings')} /></div>
            </div>

            <Dialog
                open={open2}

                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleClose2(); // Allow closing only for other reasons
                    }
                }}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >
                <DialogContent className="bg-[#FFF6DA]">

                    <DialogContent
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        <div className="items-center justify-center flex">
                            <div className='w-10 h-10 border-2 border-t-transparent border-[#FFA803] rounded-full animate-spin'></div>
                        </div>
                    </DialogContent>

                </DialogContent>
            </Dialog>
        </div>
    )
}

export default ResearcherGreetingMobilePage;